import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import FontIcon from 'react-toolbox/lib/font_icon'

import styles from './styles.scss'

const UploadIconContainer = props => {
  return (
    <Flex
      align='center'
      column
      auto
      styleName='uploadProgress'
    >
      <FontIcon
        styleName='uploadIcon'
        value='cloud_upload'
      />
      { props.children }
    </Flex>
  )
}
const withStyle = CSSModules(styles)
export default withStyle(UploadIconContainer)
